<template>
    <div class="badge" :class="classes">
        <slot></slot>
        <span v-if="badges.length" class="badge-container">
            <span class="badge-wrapper" :style="style">
                <template v-if="tooltip">
                    <el-tooltip
                        v-for="badge in badges"
                        :key="badge.label"
                        :content="badge.label"
                        placement="bottom-start"
                    >
                        <span class="badge-item" :class="[`badge-item--${badge.id}`]">
                            {{ content }}
                        </span>
                    </el-tooltip>
                </template>
                <template v-else>
                    <span
                        v-for="badge in badges"
                        :key="badge.label"
                        class="badge-item"
                        :class="[`${badge.bgcolor}-bkg`, badge.color]"
                    >
                        {{ content }}
                    </span>
                </template>
            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        badges: {
            type: Array,
            required: true,
        },
        content: {
            required: false,
        },
        dot: Boolean,
        inline: Boolean,
        tooltip: Boolean,
        bottom: Boolean,
        left: Boolean,
    },
    computed: {
        /**
         * Return classes of badge element according to props
         */
        classes() {
            return {
                dot: this.dot,
                inline: this.inline,
            };
        },
        /**
         * Return the dynammic style of badge-wrapper element according to props
         */
        style() {
            if (this.inline) return {};
            return {
                bottom: !this.bottom ? `calc(100% - ${this.offset}px)` : 'auto',
                left: !this.left ? `calc(100% - ${this.offset}px)` : 'auto',
                right: this.left ? `calc(100% - ${this.offset}px)` : 'auto',
                top: this.bottom ? `calc(100% - ${this.offset}px)` : 'auto',
            };
        },
        /**
         * Return the offset to applied for good postion of badge
         */
        offset() {
            return this.dot ? 2 : 4;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.badge {
    display: inline-block;
    line-height: 1;
    position: relative;

    &.dot {
        .badge-item {
            height: 8px;
            width: 8px;
            min-width: 0;
            border-radius: 4px;
            padding: 0;
            margin-right: 3px;
        }
    }
    &.inline {
        align-items: baseline;
        display: inline-flex;
        justify-content: center;
        .badge-container,
        .badge-wrapper {
            position: relative;
        }
        .badge-container {
            margin: 0 4px;
        }
    }

    .badge-container {
        flex: 0 1;
        height: 100%;
        width: 100%;
        left: 0px;
        top: 0px;
        pointer-events: none;
        position: absolute;
    }
    .badge-wrapper {
        display: inline-flex;
        position: absolute;
    }
    .badge-item {
        height: 20px;
        min-width: 20px;
        border-radius: 10px;
        display: inline-block;
        pointer-events: auto;
        color: $white;
        font-size: 12px;
        letter-spacing: 0;
        padding: 4px 6px;
        pointer-events: auto;
        text-align: center;
        text-indent: 0;
        top: auto;
        white-space: nowrap;

        background-color: var(--colors-component-background-information-tag-directory-company);
        border-color: var(--colors-component-border-tag-directory-company);
        color: var(--colors-component-text-tag-directory-company);

        &--contact {
            background-color: var(--colors-component-background-information-tag-directory-contact);
            border-color: var(--colors-component-border-tag-directory-contact);
            color: var(--colors-component-text-tag-directory-contact);
        }

        &--client {
            background-color: var(--colors-component-background-information-tag-directory-customer);
            border-color: var(--colors-component-border-tag-directory-customer);
            color: var(--colors-component-text-tag-directory-customer);
        }

        &--prospect {
            background-color: var(--colors-component-background-information-tag-directory-prospect);
            border-color: var(--colors-component-border-tag-directory-prospect);
            color: var(--colors-component-text-tag-directory-prospect);
        }

        &--supplier {
            background-color: var(--colors-component-background-information-tag-directory-supplier);
            border-color: var(--colors-component-border-tag-directory-supplier);
            color: var(--colors-component-text-tag-directory-supplier);
        }

        &--company {
            background-color: var(--colors-component-background-information-tag-directory-company);
            border-color: var(--colors-component-border-tag-directory-company);
            color: var(--colors-component-text-tag-directory-company);
        }

        &--individual {
            background-color: var(
                --colors-component-background-information-tag-directory-individual
            );
            border-color: var(--colors-component-border-tag-directory-individual);
            color: var(--colors-component-text-tag-directory-individual);
        }

        &--archived {
            background-color: var(--colors-component-background-information-tag-directory-archive);
            border-color: var(--colors-component-border-tag-directory-archive);
            color: var(--colors-component-text-tag-directory-archive);
        }

        &--reference {
            background-color: var(--colors-component-background-information-tag-grey);
            border-color: var(--colors-common-border-lighter);
            color: var(--colors-common-text-primary-default);
        }
    }
}
</style>
